
<div style="background-color: white;color: black; font-size: 18px;transform: skewX(-29.5deg); max-width: 250px; display: flex; flex-direction: row; ">
    <div style="transform: skewX(29.5deg); margin-left: 10px;">{{ this.Date | date: 'EEEE'}}</div>
    <div style="transform: skewX(29.5deg); margin-left: 10px; color: gray;">{{ this.Date | date: 'dd LLL'}} </div>
</div>
